/**
 * Stable CSS class names for E2E — OTP Password / SMS Password.
 */
export const SMSP = {
    page: 'otp-password-sms-password',
    loadingSection: 'otp-password-sms-password__loading-section',

    tableContainer: 'otp-password-sms-password__table-container',
    table: 'otp-password-sms-password__table',
    tableHead: 'otp-password-sms-password__table-head',
    tableHeadRow: 'otp-password-sms-password__table-head-row',
    tableHeadCellCountry: 'otp-password-sms-password__table-head-cell--country',
    tableHeadCellEndpoint: 'otp-password-sms-password__table-head-cell--endpoint',
    tableHeadCellPlatform: 'otp-password-sms-password__table-head-cell--platform',
    tableHeadCellActions: 'otp-password-sms-password__table-head-cell--actions',

    accordionsWrap: 'otp-password-sms-password__accordions-wrap',
    accordion: 'otp-password-sms-password__accordion',
    accordionSummary: 'otp-password-sms-password__accordion-summary',
    accordionExpandIcon: 'otp-password-sms-password__accordion-expand-icon',
    accordionSummaryLayout: 'otp-password-sms-password__accordion-summary-layout',
    summaryCountryCol: 'otp-password-sms-password__summary-country-col',
    summaryCountryFlagImg: 'otp-password-sms-password__summary-country-flag-img',
    summaryCountryText: 'otp-password-sms-password__summary-country-text',
    summaryEndpointCol: 'otp-password-sms-password__summary-endpoint-col',
    summaryEndpointText: 'otp-password-sms-password__summary-endpoint-text',
    summaryPlatformCol: 'otp-password-sms-password__summary-platform-col',
    summaryPlatformText: 'otp-password-sms-password__summary-platform-text',

    accordionDetails: 'otp-password-sms-password__accordion-details',
    detailsInner: 'otp-password-sms-password__details-inner',
    requestLogsHeader: 'otp-password-sms-password__request-logs-header',
    requestLogsTitle: 'otp-password-sms-password__request-logs-title',
    utcInfoIcon: 'otp-password-sms-password__utc-info-icon',

    hoursGrid: 'otp-password-sms-password__hours-grid',
    hourCard: 'otp-password-sms-password__hour-card',
    hourTimeLabel: 'otp-password-sms-password__hour-time-label',

    hourEditWrap: 'otp-password-sms-password__hour-edit-wrap',
    hourLimitInput: 'otp-password-sms-password-input--hour-limit',
    hourEditActions: 'otp-password-sms-password__hour-edit-actions',
    hourSaveButton: 'otp-password-sms-password-input--button-hour-save',
    hourCancelButton: 'otp-password-sms-password-input--button-hour-cancel',

    hourViewWrap: 'otp-password-sms-password__hour-view-wrap',
    progressBarTrack: 'otp-password-sms-password__progress-bar-track',
    progressBarFill: 'otp-password-sms-password__progress-bar-fill',
    hourCountRow: 'otp-password-sms-password__hour-count-row',
    hourCountText: 'otp-password-sms-password__hour-count-text',
    hourEditButton: 'otp-password-sms-password-input--button-hour-edit',
} as const;

export const smspCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

